// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.
export enum NoResultsVariant {
    ChannelSearch = 'ChannelSearch',
    Mentions = 'Mentions',
    FlaggedPosts = 'FlaggedPosts',
    PinnedPosts = 'PinnedPosts',
    ChannelFiles = 'ChannelFiles',
    ChannelFilesFiltered = 'ChannelFilesFiltered',
    UserGroups = 'UserGroups',
    UserGroupMembers = 'UserGroupMembers',
}

export enum NoResultsLayout {
    Vertical,
    Horizontal,
}
